import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { from } from 'rxjs';
import { AuthGuardService } from '@sc/pas-common';
import { HttpClient } from '@angular/common/http';
import { FeatureToggleService } from '@sc/pas-common';
var MainSideBarService = /** @class */ (function () {
    function MainSideBarService(http, authService, featureToggleService) {
        this.http = http;
        this.authService = authService;
        this.featureToggleService = featureToggleService;
        this.reloadMenu = new EventEmitter();
    }
    MainSideBarService.prototype.getData = function () {
        var _this = this;
        var url = './assets/json/sb-data.json?v=5';
        if (!environment.production) { // @TODO: Remove when Sitio seguro is launched
            url = './assets/json/sb-data-dev.json?v=5';
        }
        /* Feature toggle groups allows you to set a group for each item on the menu
         If the item has a group the user should be present in that group with a true value.
         If the item does not have a group it will be shown.
         If the user is with false, the item will be hidden.
         */
        return from(this.http.get(url))
            .pipe(map(function (sideBarData) {
            var user = _this.authService.user || {};
            var items = sideBarData['data']['side-bar'];
            items = _this.filterFeaturesForFeatureToggles(items);
            return tslib_1.__assign({}, sideBarData['data'], { 'side-bar': _this.filterItems(items, user) });
        }));
    };
    MainSideBarService.prototype.filterItems = function (items, user) {
        var _this = this;
        return items.filter(function (each) {
            return _this.isWithoutGroup(each);
        })
            .map(function (each) {
            if (!each.items) {
                return each;
            }
            else {
                return tslib_1.__assign({}, each, { items: _this.filterItems(each.items, user) });
            }
        });
    };
    MainSideBarService.prototype.isWithoutGroup = function (each) {
        return (!each.group);
    };
    MainSideBarService.prototype.filterFeaturesForFeatureToggles = function (menuItems) {
        menuItems = this.filterFirstLevelMenuItems(menuItems);
        this.filterSecondLevelMenuItems(menuItems);
        return menuItems;
    };
    MainSideBarService.prototype.filterFirstLevelMenuItems = function (menuItems) {
        var _this = this;
        //show or hide based on feature toggle
        if (this.featureToggleService.features) {
            menuItems = menuItems.filter(function (item) { return !_this.featureToggleService.features.find(function (y) { return y.id == item.hideForFeatureToggle; }); });
            menuItems = menuItems.filter(function (item) { return !item.showForFeatureToggle || (item.showForFeatureToggle && _this.featureToggleService.features.find(function (y) { return y.id == item.showForFeatureToggle; })); });
        }
        else {
            menuItems = menuItems.filter(function (item) { return !item.showForFeatureToggle; });
        }
        //hide based on user claim (read from jwt)
        menuItems = menuItems.filter(function (item) { return !item.hideForPermission || !_this.authService.hasPermission(item.hideForPermission); });
        return menuItems;
    };
    MainSideBarService.prototype.filterSecondLevelMenuItems = function (menuItems) {
        var _this = this;
        menuItems.forEach(function (menu) {
            if (menu.items) {
                //show or hide based on feature toggle
                if (_this.featureToggleService.features) {
                    menu.items = menu.items.filter(function (subitem) { return !_this.featureToggleService.features.find(function (feature) { return feature.id == subitem.hideForFeatureToggle; }); });
                    menu.items = menu.items.filter(function (subitem) { return !subitem.showForFeatureToggle || (subitem.showForFeatureToggle && _this.featureToggleService.features.find(function (feature) { return feature.id == subitem.showForFeatureToggle; })); });
                }
                else {
                    menu.items = menu.items.filter(function (subitem) { return !subitem.showForFeatureToggle; });
                }
                //hide based on user claim (read from jwt)
                if (menu.items.some(function (item) { return item.hideForPermission; })) {
                    menu.items = menu.items.filter(function (subitem) { return !subitem.hideForPermission || !_this.authService.hasPermission(subitem.hideForPermission); });
                }
            }
        });
    };
    MainSideBarService.prototype.forceMenuReload = function (newSelectedRoute) {
        this.reloadMenu.emit(newSelectedRoute);
    };
    return MainSideBarService;
}());
export { MainSideBarService };
